import type { MeshNode } from "../../domain/mesh";
import { minutesAgo } from "./time";

export function createMockNodes(origin = Date.now()): MeshNode[] {
  const ago = (minutes: number) => minutesAgo(minutes, origin);
  return [
    {
      id: "kaim-dev",
      copyKey: "kaimDev",
      kind: "system",
      status: "online",
      cluster: "core",
      href: "https://kaim.dev",
      metrics: { version: "frontier", updatedAt: ago(128), meta: "PUBLIC EDGE" },
    },
    {
      id: "goals",
      copyKey: "goals",
      kind: "system",
      status: "online",
      cluster: "projects",
      href: "https://goals.kaim.dev",
      metrics: { progress: 31, count: 100, version: "1.7.9", updatedAt: ago(28), meta: "MARKET INTEGRITY ONLINE" },
    },
    {
      id: "build",
      copyKey: "build",
      kind: "system",
      status: "building",
      cluster: "life",
      metrics: { progress: 8, version: "PRE-ALPHA", updatedAt: ago(4), meta: "PRE-CONSTRUCTION" },
    },
    {
      id: "photos",
      copyKey: "photos",
      kind: "system",
      status: "online",
      cluster: "memory",
      href: "https://photos.kaim.dev",
      metrics: { count: 20769, updatedAt: ago(410), meta: "ARCHIVE INDEXED" },
    },
    {
      id: "breakglass",
      copyKey: "breakglass",
      kind: "system",
      status: "online",
      cluster: "projects",
      href: "https://breakglass.kaim.dev",
      metrics: { version: "1.3.1", updatedAt: ago(840), meta: "PUBLIC EDGE" },
    },
    {
      id: "home",
      copyKey: "home",
      kind: "system",
      status: "draft",
      cluster: "infrastructure",
      metrics: { progress: 3, updatedAt: ago(90), meta: "AWAITING PHYSICAL HOST" },
    },
    {
      id: "okolica",
      copyKey: "okolica",
      kind: "system",
      status: "active",
      cluster: "projects",
      metrics: { version: "2.0", updatedAt: ago(2380), meta: "PARCEL ENGINE" },
    },
    {
      id: "michalowice",
      copyKey: "michalowice",
      kind: "location",
      status: "active",
      cluster: "life",
      metrics: { updatedAt: ago(1390), meta: "PLOT ACQUIRED" },
    },
    {
      id: "house-goal",
      copyKey: "houseGoal",
      kind: "goal",
      status: "active",
      cluster: "life",
      metrics: { progress: 11, updatedAt: ago(72), meta: "LONG HORIZON" },
    },
    {
      id: "house",
      copyKey: "house",
      kind: "entity",
      status: "building",
      cluster: "life",
      metrics: { progress: 8, updatedAt: ago(4), meta: "PHYSICAL ASSET" },
    },
    {
      id: "market-engine",
      copyKey: "marketEngine",
      kind: "artifact",
      status: "online",
      cluster: "projects",
      metrics: { version: "1.7.9", updatedAt: ago(44), meta: "DURABLE OBJECT" },
    },
    {
      id: "portfolio-frontier",
      copyKey: "portfolioFrontier",
      kind: "artifact",
      status: "online",
      cluster: "core",
      metrics: { version: "917cc61", updatedAt: ago(128), meta: "EDGE RUNTIME" },
    },
    {
      id: "photo-archive",
      copyKey: "photoArchive",
      kind: "artifact",
      status: "online",
      cluster: "memory",
      metrics: { count: 20769, updatedAt: ago(410), meta: "MANIFEST READY" },
    },
    {
      id: "afery-lekarskie",
      copyKey: "aferyLekarskie",
      kind: "system",
      status: "online",
      cluster: "projects",
      href: "https://aferylekarskie.pl",
      metrics: { version: "v36", updatedAt: ago(60), meta: "STATIC EDGE" },
    },
  ];
}
